import { MapboxAttribution } from '../../MapboxAttribution/MapboxAttribution';

export const CatchMapHeader = () => (
  <div className="z-mid col-start-1 row-start-1 flex size-full flex-col">
    <div className="flex justify-end p-1">
      <MapboxAttribution className="relative" isLinked={true} />
    </div>
  </div>
);
